"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnabledLanguages = void 0;
var EnabledLanguages;
(function (EnabledLanguages) {
    EnabledLanguages["EN"] = "EN";
    EnabledLanguages["RU"] = "RU";
})(EnabledLanguages || (exports.EnabledLanguages = EnabledLanguages = {}));
//# sourceMappingURL=language.js.map